import React, { useRef, useState } from 'react';

import classNames from 'classnames';
import Image from 'gatsby-plugin-sanity-image';
import Slider from 'react-slick';

import { AlmaLink } from '../alma-link';

import './imageSlider.scss';

export function ImageSlider({
	backgroundColor,
	cta,
	header,
	mobileSliderDots,
	sliderProfiles,
	textColor,
}) {
	// state
	const [autoplay, setAutoplay] = useState(true);
	let slickEl = useRef();

	const hasImages = sliderProfiles?.some((profile) => profile?.image);

	const settings = {
		infinite: true,
		slidesToShow: hasImages ? 4.5 : 1.5,
		autoplay: autoplay,
		speed: 1000,
		unslick: false,
		slidesToScroll: 0.1,
		autoplaySpeed: 0,
		cssEase: 'linear',
		centerMode: false,
		arrows: false,
		dots: false,
		responsive: [
			{
				breakpoint: 799,
				settings: {
					autoplaySpeed: 6000,
					autoplay: true,
					dots: true,
					slidesToShow: hasImages ? 2 : 1,
					slidesToScroll: 1,
					speed: 2000,
				},
			},
			{
				breakpoint: 1279,
				settings: {
					autoplaySpeed: 4000,
					autoplay: true,
					dots: true,
					slidesToShow: hasImages ? 3 : 2,
					slidesToScroll: hasImages ? 3 : 2,
					speed: hasImages ? 100 : 200,
				},
			},
		],
	};

	const onMouseOver = () => {
		slickEl.slickPause();
	};
	const onMouseLeave = () => {
		slickEl.slickPlay();
		setAutoplay(true);
	};

	return (
		<div
			className={classNames(
				backgroundColor && `b${backgroundColor}`,
				textColor
			)}
			id='slider'
		>
			{header && (
				<div className='header-container f x jcb aic'>
					<h2 className='heading-l'>{header}</h2>
					{cta && <AlmaLink cta={cta} key={cta._key} />}
				</div>
			)}
			<div
				className={classNames(
					'provider-images-grid',
					!hasImages && 'quote-style',
					mobileSliderDots && `dots-${mobileSliderDots}`
				)}
				role='menu'
			>
				<Slider ref={(c) => (slickEl = c)} {...settings}>
					{sliderProfiles?.map((profile) => {
						const image = profile.image;
						const { _key } = profile;

						return (
							<div
								className='provider-block'
								onMouseOver={onMouseOver}
								onFocus={onMouseOver}
								onMouseLeave={onMouseLeave}
								key={_key}
								role='menuitem'
								tabIndex={0}
							>
								{hasImages ? (
									<a
										href={profile.link}
										rel='noreferrer'
										target='_blank'
									>
										{image?.asset && (
											<Image
												alt={image.alt || ''}
												className='x'
												loading='lazy'
												{...image}
											/>
										)}
										<h4 className='py05'>{profile.name}</h4>
										<p className='cg'>
											{profile.testimonial}
										</p>
									</a>
								) : (
									<div className='quote-container'>
										<h3 className='cg'>
											{profile.testimonial}
										</h3>
										<p className='py05 cgr'>
											{profile.name}
										</p>
									</div>
								)}
							</div>
						);
					})}
				</Slider>
			</div>
		</div>
	);
}
